import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import * as notificationAction from "../../../../redux/actions/notification.action";
import { formatDate } from "../../../../helpers/date";
import List from '../../../list/list';
import { useTranslation } from "react-i18next";
import RetireePortalToggle from "../../../RetireePortalToggle/RetireePortalToggle";

const notificationFields = [
  //list will sort by the first element by default
  "createdAt",
  "type",
  "start_date",
  "end_date",
  "scope",
];

const NotificationList = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation();
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const { notifications, meta, listLoading, error } = useSelector((state) => ({
    notifications: state.notification.notificationList,
    meta: state.notification.notificationMetadata,
    listLoading: state.notification.listLoading,
    error: state.notification.error,
  }));

  const initialParams = {
    fieldTofilter: "type",
    filter: "",
    fieldToSort: "id",
    sortDirection: "asc",
    page: 1,
    pageSize: 10,
    memberFilters: { all: true, members: [], groups: [] },
  };

  useEffect(() => {
    notificationAction.fetchAll(dispatch, initialParams);
  }, [dispatch]);

  const handleToggleRetireePortal = async (notificationId, currentStatus) => {
    // Clear any previous messages
    setErrorMessage("");
    setAlertMessage("");
    setShowAlert(false);

    let success = false;

    try {
      // Find the notification data to send complete information
      const notificationToUpdate = notifications?.data?.find(notification => notification.id === notificationId);
      if (!notificationToUpdate) {
        throw new Error('Notification not found');
      }

      const formData = new FormData();
      const { attributes } = notificationToUpdate;

      const formBody = { ...attributes, show_in_retiree_portals: !attributes.show_in_retiree_portals }

      formData.append("data", JSON.stringify(formBody));
      await notificationAction.update(dispatch, notificationId, formData);

      // Refresh the list to show updated data
      await notificationAction.fetchAll(dispatch, initialParams);
      // Show appropriate message based on success flag
      const message = !currentStatus
        ? "Notification successfully added to retiree portals"
        : "Notification successfully removed from retiree portals";
      setAlertMessage(message);
      setShowAlert(true); 
    } catch (error) {
      console.error('Error updating retiree portal status:', error);
      setErrorMessage("Error updating retiree portal status. Please try again.");
    }

   
  };

	return (
		<List
			redirect='/notifications/form'
			title={t('notifications.notifications')}
			isOverview={false}
      columnNames={[
        "TYPE",
        "DATE SENT",
        "SCOPE",
        "START DATE",
        "END DATE",
        "Medicare Portals",
      ]}
			entities={notifications?.data?.map(
        ({ id, attributes: { type, createdAt, start_date, end_date, user_scope, show_in_retiree_portals} }) => ({
          id,
          columns: [
						{ primary: type },
            { primary: formatDate(createdAt) },
            { primary: user_scope},
						{ primary: start_date },
						{ primary: end_date },
            {
              primary: (
                <RetireePortalToggle
                  id={id}
                  showInRetireePortals={show_in_retiree_portals}
                  onClick={(notificationId) => handleToggleRetireePortal(notificationId, show_in_retiree_portals)}
                />
              )
            }
					],
          name: "this notification",
        })
      )}
      isEditable={true}
      tooltipTextDelete="Delete Notification"
      fieldsToSort={notificationFields}
      fetchAction={(params) => notificationAction.fetchAll(dispatch, {...initialParams, ...params})}
      metadata={meta}
      deleteAction={(id, params) => notificationAction.remove(dispatch, id, params)}
      loading={listLoading}
      showAlert={showAlert}
      setShowAlert={setShowAlert}
      successAlertMessage={alertMessage}
      customListError={errorMessage}
		/>
	);
};

export default NotificationList;
